// initialise window.Utiq API configuration
export const initialiseConsentManagerUtiqApiFunctions = (
  showUtiqConsentManager: CallableFunction,
) => {
  window.Utiq ||= {};
  window.Utiq.API ||= {};
  window.Utiq.API.showConsentManager = showUtiqConsentManager;
};
